import { CheckCheck, Check } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PersonAvatar } from "../UserImage";

const fmt = (iso) => new Date(iso).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

function Row({ u, at, testid }) {
  return (
    <div data-testid={testid} className="flex items-center gap-2.5 py-1.5">
      <PersonAvatar name={u.name} size={30} />
      <span className="min-w-0 flex-1 truncate text-sm font-medium text-zinc-800">{u.name}</span>
      {at && <span className="shrink-0 text-[11px] text-zinc-500">{fmt(at)}</span>}
    </div>
  );
}

export function ReadByDialog({ msg, chat, me, onClose }) {
  if (!msg) return null;
  const ch = msg.channel;
  const reads = chat.state.reads[ch] || {};
  const users = (chat.state.members[ch] || []).filter((id) => id !== msg.author_id).map((id) => chat.state.users.find((u) => u.id === id)).filter(Boolean);
  const read = users.filter((u) => (reads[u.id] || "") >= msg.created_at).sort((a, b) => reads[b.id].localeCompare(reads[a.id]));
  const unread = users.filter((u) => !read.includes(u)).sort((a, b) => a.name.localeCompare(b.name));
  return (
    <Dialog open={!!msg} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="read-by-dialog" className="max-h-[85vh] max-w-md overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Message info</DialogTitle>
          <DialogDescription className="line-clamp-2">{msg.text || msg.attachment?.name}</DialogDescription>
        </DialogHeader>
        <div>
          <div className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[#34B7F1]"><CheckCheck className="h-4 w-4" />Read by <span data-testid="read-by-count">{read.length}</span></div>
          <div className="mt-1 divide-y divide-zinc-100">{read.map((u) => <Row key={u.id} u={u} at={reads[u.id]} testid={`read-by-${u.id}`} />)}</div>
          {!read.length && <div className="py-2 text-xs text-zinc-400">Nobody has read it yet.</div>}
        </div>
        <div className="mt-3">
          <div className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-zinc-500"><Check className="h-4 w-4" />Not read yet <span data-testid="unread-by-count">{unread.length}</span></div>
          <div className="mt-1 divide-y divide-zinc-100">{unread.map((u) => <Row key={u.id} u={u} testid={`unread-by-${u.id}`} />)}</div>
          {!unread.length && <div className="py-2 text-xs text-zinc-400">Everyone has read it.</div>}
        </div>
        {msg.author_id !== me && <p className="text-[11px] text-zinc-400">Sent by {msg.author}.</p>}
      </DialogContent>
    </Dialog>
  );
}
